import getConfig from 'next/config'

export const getSecureCookieFlag = (): boolean => {
  const { publicRuntimeConfig } = getConfig()
  return publicRuntimeConfig?.releaseEnv !== 'development'
}

export default getSecureCookieFlag
